<template>

  <div :class="['envNotice', environment]" v-if="showEnvNotice">

    <div class="env">{{ environment == 'dev' ? 'DEV' : 'VorProd' }}</div>
    <div class="version">MWB v{{ appVersion }}<template v-if="apiVersion"> | MWB-API v{{ apiVersion }}</template></div>

  </div>

</template>


<script>

export default {

  name: 'envNoticeBanner',

  components: {

  },

  data() {
    return {

    };
  },

  computed: {

    environment() {
      return this.$store.getters.getEnvType;
    },

    apiVersion() {
      return this.$store.getters.getApiVersion;
    },

    appVersion() {
      return process.env.VUE_APP_VERSION;
    },

    showEnvNotice() {
      return true;
      // return this.siteConfig.environment == 'stage' || this.siteConfig.environment == 'dev';
    },

    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

  },

}
</script>

<style lang="scss" scoped>

  .envNotice {
    position: fixed; 
    z-index:59; 
    display: flex; 
    align-items: center; 
    height: 32px; 
    left:0; 
    right:0;
    top:0;
    color: white;
    gap: 12px;
    padding: 0 0 0 16px;

    &.stage {
      color: #663300;
      background-color: #FFD9B3;
      box-shadow: 0 -2px 6px 0 #a1978e;
    }
    &.dev {
      color: #003366;
      background-color: #CCE5FF;
      box-shadow: 0 -2px 6px 0 #7e8791;
    }

    .env {
      font-size: 14px;
      font-weight: bold;
      line-height: normal;
    }
    .version {
      font-size: 8.5px;
      line-height: normal;
      padding-top: 1px;
    }

  }
</style>
